const CJK_REGEX = /[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff]/

export function containsChinese(text: string): boolean {
  return CJK_REGEX.test(text)
}

export function validateEnglishText(text: string): boolean {
  const trimmed = text.trim()
  return trimmed.length > 0 && !containsChinese(trimmed)
}

export function validateChineseText(text: string): boolean {
  const trimmed = text.trim()
  return trimmed.length > 0 && containsChinese(trimmed)
}
